<div class="search-container">
    <form [formGroup]="searchForm" (keydown.enter)="$event.preventDefault()"> 
        <input formControlName="search" type="text" class="form-control"id="search"  (keyup)="onChangeInput()" [placeholder]="'search' | translate">
    </form>
</div>